import React from 'react'
import { Typography } from '@mui/material'
import { useStyles } from './style'
import { useGroup } from '../../hooks/index'
import { useNavigate } from 'react-router'
import { routes } from '../../routes'
import { ALLOW_REPORTING } from '../../util/permissions'
import Illustration from '../../components/illustration'

const HomePage = () => {
  const classes = useStyles()
  const navigate = useNavigate()
  const { groups } = useGroup()

  React.useEffect(() => {
    if (groups?.includes(ALLOW_REPORTING)) {
      navigate(routes.reporting.path)
    }
  }, [groups, navigate])

  return (
    <>
      <div className={classes.root} />
      <div className={classes.content}>
        <Illustration size='570px' />
        <div className={classes.textContainer}>
          <Typography variant='h2' className={classes.title}>
            Welcome to The Ark
          </Typography>
          <Typography variant='h5' className={classes.subtitle}>
            Let's build knowledge, skills, and impact together.
          </Typography>
        </div>
      </div>
    </>
  )
}

export default HomePage
